// extracted by mini-css-extract-plugin
export default {"accuracyScore":"AccuracyScore_accuracyScore__Maqc2","passingScore":"AccuracyScore_passingScore__wSmYa","notPassingScore":"AccuracyScore_notPassingScore__2ZGHZ"};